import api from "./api";
const contasContabeisService = {
  listar:        (p={}) => { const qs=new URLSearchParams(Object.entries(p).filter(([,v])=>v!==""&&v!==undefined)); return api("GET",`/contas-contabeis?${qs}`); },
  buscarPorId:   (id)   => api("GET",`/contas-contabeis/${id}`),
  criar:         (data) => api("POST","/contas-contabeis",data),
  atualizar:     (id,data) => api("PUT",`/contas-contabeis/${id}`,data),
  deletar:       (id)   => api("DELETE",`/contas-contabeis/${id}`),
  copiar:        (data) => api("POST","/contas-contabeis/copiar",data),
  previewCopiar:     (idOrigem,idDestino) => api("GET",`/contas-contabeis/preview-copiar?idOrigem=${idOrigem}&idDestino=${idDestino}`),
  importarPlanoPadrao: (idCondominio) => api("POST","/contas-contabeis/plano-padrao",{idCondominio}),
  normalizar:    (idCondominio) => api("POST","/contas-contabeis/normalizar",{idCondominio}),
};
export default contasContabeisService;
